module.exports = __webpack_public_path__ + "img/COVID_Public_Mobile_Banner.02695147.jpg";